module.exports = __webpack_public_path__ + "static/media/abt.90a0e76a.svg";